import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer/dist/react-pdf.es';


const styles = StyleSheet.create({
    container:{
        flexDirection: 'column',
        //marginLeft:15,
        //marginRight:15,
        //fontSize: 14,
        //textAlign: 'justify',
        height:'45mm',
        width:'85mm',
        paddingLeft:'5mm',
        paddingTop:'22.7mm',
        marginTop:-12,
    },
    address: {
        fontFamily: 'Lato',
        fontSize:12,
        lineHeight:'1.5rem',
    }

});

export default ({...props}) => {
    const {contact} = props;

    return (
        <View style={styles.container}>
            {contact && (
                <View style={styles.address}>
                    <Text>{contact.company_name}</Text>
                    <Text>{contact.street} {contact.number}</Text>
                    <Text>{contact.zip} {contact.city}</Text>
                </View>
            )}
        </View>
    );
}
